import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { ensureVisitorSession, trackEvent } from '../../utils/visitorTracking';
const LANDING_FLAG_KEY = 'toxicdetector_landing_tracked';

/**
 * Mounts once inside the router. Creates exactly one `visitor_sessions` row per
 * browser session and emits exactly one `page_view` per SPA navigation.
 * Independent of GA4 — this populates the first-party Supabase tables.
 */
export function VisitorTracker() {
  const location = useLocation();
  const lastPathRef = useRef<string | null>(null);
  useEffect(() => {
    void ensureVisitorSession();
  }, []);
  useEffect(() => {
    const path = location.pathname;
    // Guards React Strict Mode's double-invoked effect and any remount that
    // re-fires for the path we just recorded.
    if (lastPathRef.current === path) return;
    lastPathRef.current = path;
    void (async () => {
      await ensureVisitorSession();
      let isLanding = false;
      try {
        isLanding = !window.sessionStorage.getItem(LANDING_FLAG_KEY);
        if (isLanding) {
          window.sessionStorage.setItem(LANDING_FLAG_KEY, path);
        }
      } catch {
        /* storage unavailable — fall back to a plain page_view */
      }
      if (isLanding) {
        await trackEvent('landing_page_view', {
          path,
          search: location.search || null
        });
      }
      await trackEvent('page_view', {
        path,
        search: location.search || null
      });
    })();
  }, [location.pathname, location.search]);
  return null;
}